import { Injectable, inject } from '@angular/core';
import { ModalRef, SiModalService } from '@siemens/element-ng/modal';
import { EnergyBannerDialogComponent } from '../components/energy-banner-dialog/energy-banner-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class EnergyBannerDialogService {
    private readonly modalService = inject(SiModalService);
    private currentModalRef: ModalRef<EnergyBannerDialogComponent, string> | null = null;

    public openDialog(): ModalRef<EnergyBannerDialogComponent, string> {
        if (this.currentModalRef) {
            return this.currentModalRef;
        }

        const modalRef = this.modalService.show(
            EnergyBannerDialogComponent,
            {
                class: 'modal-lg',
                ignoreBackdropClick: true,
                keyboard: false,
                animated: true
            },
            'close'
        );

        this.currentModalRef = modalRef;

        modalRef.hidden.subscribe(() => {
            this.currentModalRef = null;
        });

        return modalRef;
    }
}
